// + [menu.ts]
// h/t https://github.com/chakra-ui/chakra-ui/blob/v1/packages/theme/src/components/menu.ts
import { menuAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';
import type { SystemStyleObject } from '@chakra-ui/theme-tools';

// eslint-disable-next-line @typescript-eslint/unbound-method
const { definePartsStyle } = createMultiStyleConfigHelpers(menuAnatomy.keys);

const sltMenuVariants = ['slt-shipping-menu', 'slt-dropdown', 'slt-dropdown-outline'] as const;
export type SLTMenuVariant = (typeof sltMenuVariants)[number];

const shippingMenuList: SystemStyleObject = {
    color: 'inherit',
    width: '100%',
    minW: '3xs',
    py: '7px',
    zIndex: 3,
    borderRadius: '4px',
    borderWidth: '1px',
    borderColor: 'slt-black.900',
};

const shippingMenuListItem: SystemStyleObject = {
    py: '7px',
    px: '4',
    transitionProperty: 'background',
    transitionDuration: 'ultra-fast',
    transitionTimingFunction: 'ease-in',
    _focus: {
        bg: 'slt-black.50',
    },
    _active: {
        bg: 'slt-black.50',
    },
    _expanded: {
        bg: 'slt-black.50',
    },
    _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
    },
};
const shippingMenuGroupTitle: SystemStyleObject = {
    margin: 0,
    height: '7px',
    fontWeight: 'semibold',
    fontSize: 'sm',
};
const shippingMenuButton: SystemStyleObject = {
    transitionProperty: 'common',
    transitionDuration: 'normal',
};

const sltDropdown = definePartsStyle({
    button: defineStyle({
        backgroundColor: 'white',
        textStyle: { xs: 'body-small', md: 'body-base' },
        textAlign: 'start',
        paddingX: 3,
        paddingY: 2,
        width: 'fit-content',
        lineHeight: '.75rem',
        whiteSpace: 'nowrap',
        color: 'slt-pepper.1000',
        display: 'flex',
        flexShrink: 0,
    }),
    list: defineStyle({
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 1,
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'slt-pepper.300',
        backgroundColor: 'slt-pepper.100',
        boxShadow: '0px 2px 10px 0px rgba(65, 64, 66, 0.14)',
    }),
    item: defineStyle({
        paddingY: 0,
        paddingX: 1,
        backgroundColor: 'slt-pepper.100',
        textTransform: 'uppercase',
        textStyle: 'body-base',
    }),
});

const sltDropdownOutline = definePartsStyle({
    ...sltDropdown,
    button: defineStyle({
        ...sltDropdown.button,
        border: '1px solid',
        borderColor: 'slt-pepper.1000',
        borderRadius: '4px',
    }),
});

const sltVariants: Record<SLTMenuVariant, SystemStyleObject> = {
    'slt-shipping-menu': {
        button: shippingMenuButton,
        groupTitle: shippingMenuGroupTitle,
        list: shippingMenuList,
        item: shippingMenuListItem,
    },
    'slt-dropdown': sltDropdown,
    'slt-dropdown-outline': sltDropdownOutline,
};
export const Menu = {
    variants: sltVariants,
};
